<script setup lang="ts">
const props = defineProps<{
  color: string;
}>();
</script>
<template>
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.33329 0.333984H15.6666C16.5858 0.333984 17.3333 1.08148 17.3333 2.00065V12.0007C17.3333 12.9198 16.5858 13.6673 15.6666 13.6673H3.99996L0.666626 17.0007V2.00065C0.666626 1.08148 1.41413 0.333984 2.33329 0.333984Z"
      :fill="color"
    />
  </svg>
</template>
